<template>
  <l-marker
      v-for="(point, index) in quotes"
      :key="'quotes-' + index"
      :lat-lng="[point.Latitude, point.Longitude]"
      :icon="divIcon"
      @click="onOverlayClick(point)"
    ></l-marker>
</template>

<script setup>

import { LMarker } from '@vue-leaflet/vue-leaflet';
import { computed } from "vue";

import { useStore } from 'vuex';
const store = useStore();

const quotes = computed(() => store.getters.quotes);

store.dispatch('loadQuotes');

const myCustomColour = 'rgb(255 83 98 / 62%)';

 let iconSettings2 = {
    mapIconUrl: '<svg width="31" height="32" viewBox="0 0 31 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_39_74)"><path d="M4.02191 25.9538L4.19213 25.6546L3.97333 25.3888C1.80719 22.7576 0.5 19.3713 0.5 15.6814C0.5 7.29237 7.2246 0.5 15.5064 0.5C23.7757 0.5 30.5129 7.29265 30.5129 15.6814C30.5129 24.0705 23.7883 30.8629 15.5064 30.8629C12.8446 30.8629 10.3572 30.1587 8.19163 28.9379L7.99867 28.8291L7.78846 28.8989L1.07878 31.1278L4.02191 25.9538Z" fill="#FF5362" stroke="#FFC5CC"/><path d="M11.5849 21.4547C9.70764 21.4547 8.07471 20.0894 8.07471 17.3198C8.07471 11.5725 11.7777 9.10198 14.4779 8.80292V11.0914C12.3563 11.5725 10.9163 13.822 10.8648 15.8115C11.0063 15.7074 11.3406 15.5644 11.8292 15.5644C13.4107 15.5644 14.7222 16.6826 14.7222 18.529C14.7222 20.1284 13.3721 21.4547 11.5977 21.4547H11.5849ZM19.8138 21.4547C17.9366 21.4547 16.3037 20.0894 16.3037 17.3198C16.3037 11.5725 20.0067 9.10198 22.7068 8.80292V11.0914C20.5853 11.5725 19.1452 13.822 19.0938 15.8115C19.2352 15.7074 19.5695 15.5644 20.0581 15.5644C21.6396 15.5644 22.9382 16.6826 22.9382 18.529C22.9382 20.1284 21.5882 21.4547 19.8138 21.4547Z" fill="black"/></g><defs><clipPath id="clip0_39_74"><rect width="31" height="32" fill="white"/></clipPath></defs></svg>',
    mapIconColor: '#cc756b',
    mapIconColorInnerCircle: '#fff',
    pinInnerCircleRadius: 48
 }

    // icon normal state
let divIcon = L.divIcon({
    className: "leaflet-data-marker",
    html: L.Util.template(iconSettings2.mapIconUrl, iconSettings2),
    iconAnchor: [0, 32],
    iconSize: [31, 32],
    popupAnchor: [0, -25]
})

    // icon active state
let divIconActive = L.divIcon({
    className: "leaflet-data-marker",
    html: L.Util.template(iconSettings2.mapIconUrl, iconSettings2),
    iconAnchor: [18, 42],
    iconSize: [36, 42],
    popupAnchor: [0, -30]
})

function onOverlayClick(marker) {
  store.dispatch('updateFeatured', marker);
  // marker.setIcon(divIconActive);
}

</script>

<style lang="scss">
.marker-cluster span {
  font-family: var(--font-body);
}
</style>